import { render, staticRenderFns } from "./PreviewInvoicesButton.vue?vue&type=template&id=3a0cba24&"
import script from "./PreviewInvoicesButton.vue?vue&type=script&lang=js&"
export * from "./PreviewInvoicesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports